import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Box } from '@mui/material';

interface MarkdownContentProps {
  children: string;
}

const MarkdownContent: React.FC<MarkdownContentProps> = ({ children }) => (
  <Box
    sx={{
      '& p': { margin: 0, mb: 1, lineHeight: 1.7 },
      '& p:last-child': { mb: 0 },
      '& ul, & ol': { mt: 0.5, mb: 1, pl: 2.5 },
      '& li': { mb: 0.5, lineHeight: 1.7 },
      '& strong': { fontWeight: 600 },
      '& em': { fontStyle: 'italic' },
      '& hr': { border: 'none', borderTop: '1px solid', borderColor: 'divider', my: 1.5 },
      '& h1, & h2, & h3': { mt: 1.5, mb: 0.5, fontWeight: 600 },
      fontSize: 'inherit',
      color: 'inherit',
    }}
  >
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
  </Box>
);

export default MarkdownContent;
